import {apiGet, apiPost, apiPut} from "./api";

export const createAccount = async (accountData) => {
    return await apiPost(`organizations`, accountData);
}

export const getListOrgByAccountId = async (accountId) => {
    return await apiGet(`/admin/account/${accountId}` , {});
}

export const adminUpdateAccount = async (data) => {
    return await apiPut(`/admin/settings/account` , data);
}
export const adminUpdateOrg = async (data) => {
    return await apiPut(`/admin/settings/org` , data);
}